import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { path } from 'ramda';
import { createRoot } from 'react-dom/client';

// Actions
import { getSeb } from './actions';

class SharingEverithingBundle extends Component {
  constructor(props) {
    super(props);

    this.state = {
      Service: null,
      sebData: null,
    };
    this.containerRef = createRef();
    this.root = null;
  }

  componentDidMount() {
    this.props.actions.getSeb();

    this.interval = setInterval(() => {
      const Service = path(['beeline', 'pages', 'SharingServiceExtension'], window);
      if (Service) {
        this.setState({ Service });
        clearInterval(this.interval);
      }
    }, 50);
  }

  static getDerivedStateFromProps = (nextProps) => ({
    sebData: nextProps.sebData,
  });

  componentDidUpdate() {
    if (this.state.Service && this.state.sebData && this.containerRef.current) {
      this.renderServiceInIsolation();
    }
  }

  componentWillUnmount() {
    if (this.root) {
      this.root.unmount();
    }
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  renderServiceInIsolation() {
    const { Service, sebData } = this.state;
    const { currentCtn } = this.props;

    if (!this.containerRef.current) return;

    if (!this.root) {
      this.root = createRoot(this.containerRef.current);
    }

    // Добавлен рут для глобальных компонентов React<18
    this.root.render(React.createElement(Service, { data: sebData, ctn: currentCtn }));
  }

  render() {
    const { sebData, Service } = this.state;

    if (!sebData || !Service) return null;

    return <div ref={this.containerRef} />;
  }
}

SharingEverithingBundle.propTypes = {
  sebData: PropTypes.object,
  currentCtn: PropTypes.object,
  actions: PropTypes.shape({
    getSeb: PropTypes.func,
  }),
};

const mapStateToProps = (state) => ({
  sebData: path(['application', 'sebData'], state),
  currentCtn: path(['application', 'settings', 'ctn'], state),
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    getSeb,
  }, dispatch),
});

export default connect(
  mapStateToProps, mapDispatchToProps,
)(SharingEverithingBundle);
